import React, { Component } from "react";
import PanjayathList from "./PanjayathList";
import PanjayathAddEdit from "./PanjayathAddEdit";

class Panjayath extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <PanjayathList onClick={this.handleClick} />;
    } else {
      return (
        <PanjayathAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data });
    this.setState({ mode });
  }
}

export default Panjayath;
